import { VERSION } from "../apiConstant";
import BaseApi from "../baseApi";

class VersionApi extends BaseApi {
  constructor() {
    super();
    this.BASE_URL = process.env.REACT_APP_AUTHENTICATION_API_URL || "";
    this.$axiosInstance = this.initAxiosInstance();
  }

  getList(body) {
    return this.post(`${VERSION}/list`, body);
  }

  store(body) {
    return this.post(`${VERSION}/store`, body);
  }

  delete(body) {
    return this.post(`${VERSION}/delete`, body);
  }
}
export default VersionApi;
